import React from 'react'
import Link from 'gatsby-link'

import ProjectPreview from '../components/ProjectPreview'
import AHref from '../components/AHref'

import mca from '../assets/mca-preview_925.jpg'
import paypal from '../assets/p2p-preview_925.jpg'
import uts from '../assets/uts-preview_925.jpg'
import kincare from '../assets/kincare-preview_925.jpg'
import wsu from '../assets/wsu-preview_925.jpg'
import gumtree from '../assets/gumtree-preview_925.jpg'

const IndexPage = () => (
  <div>
    <div className="introduction inner">
      <h1>Hello there! I&#39;m Natalie Johnson. I&#39;m a designer and developer working in Sydney, Australia.</h1>
    </div>
    <div className="inner projects">
      <div className="row between-xs">
      <ProjectPreview
        image={paypal}
        heading="Designing safer and easier ways to buy and sell"
        client="Gumtree Australia"
        link="projects/gumtree-paypal"
      >
      </ProjectPreview>
        <ProjectPreview
          image={mca}
          heading="Designing a destination for continuous discovery"
          client="Museum of Contemporary Art Australia"
          link="/projects/mca/"
        >
        </ProjectPreview>
      </div>

      <div className="row between-xs">
        <ProjectPreview
          heading="An interactive library tour experience"
          client="Western Sydney University Library"
          link="projects/wsu-library"
          image={wsu}
        >
        </ProjectPreview>
        <ProjectPreview
          image={uts}
          heading="Updating a design subject"
          link="projects/uts-web-media"
          client="The University of Technology Sydney"
        >
        </ProjectPreview>
      </div>

      <div className="row between-xs">
        <ProjectPreview
          image={gumtree}
          heading="Evolving and optimising Australia&rsquo;s marketplace"
          link="projects/gumtree"
          client="Gumtree Australia"
        >
        </ProjectPreview>
        <ProjectPreview
          className="right"
          heading="A new platform to support the leaders of in-home care"
          image={kincare}
          link="projects/kincare"
          client="KinCare"
        >
        </ProjectPreview>
      </div>
      <div className="contact-panel">
        <h3>Interested in working together&#63; I&rsquo;m always open to hearing about exciting projects. Please feel free to say hello!</h3>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col-xs-16 col-sm-8 col-md-6">
            <ul className="h3"><h3>Get in touch</h3>
              <li className="h3"><AHref url="mailto:natalie@nataliejohnson.com">natalie@nataliejohnson.com</AHref></li>
              <li className="h3"><AHref url="tel:+61437685619">+61 437 685 619</AHref></li>
            </ul>
          </div>
          <div className="col-xs-16 col-sm-6">
            <ul className="h3"><h3>Connect</h3>
              <li className="h3"><AHref url="https://www.linkedin.com/in/natalie-johnson-33a55638/">LinkedIn</AHref></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js